module.exports = __webpack_public_path__ + "static/media/salt-sugar.4818215a.webp";